module.exports = __webpack_public_path__ + "img/collar button diameter.afc68bc0.png";